/**
 * Utility functions for date formatting with Kazakhstan timezone
 */

// Kazakhstan timezone offset is UTC+6
const KAZAKHSTAN_TIMEZONE = 'Asia/Almaty';

/**
 * Format a date string to local Kazakhstan format
 * @param dateString ISO date string
 * @returns Formatted date string in Kazakhstan timezone
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  return new Intl.DateTimeFormat('ru-KZ', {
    timeZone: KAZAKHSTAN_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

/**
 * Get current date in Kazakhstan timezone
 * @returns Current date in YYYY-MM-DD format
 */
export const getCurrentDateKZ = (): string => {
  const now = new Date();
  
  // Format as YYYY-MM-DD for input fields
  const formatter = new Intl.DateTimeFormat('fr-CA', {
    timeZone: KAZAKHSTAN_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  
  return formatter.format(now);
};

/**
 * Format date for display in Kazakhstan timezone
 * @param dateString ISO date string
 * @returns Formatted date for display
 */
export const formatDateForDisplay = (dateString: string): string => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  
  return new Intl.DateTimeFormat('ru-KZ', {
    timeZone: KAZAKHSTAN_TIMEZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
}; 